import React from "react";
import {
  Tabs as BaseTabs,
  TabList as BaseTabList,
  TabPanel as BaseTabPanel,
  Tab as BaseTab
} from "react-tabs";
import * as styles from "./SectionTabs.module.scss";
import classNames from "classnames/bind";
import { Icon, IconName } from "@silversea-ssc/ui-components-react";
const cx = classNames.bind(styles);

interface SectionTabsTabProps {
  icon?: IconName;
  variant?: "regular" | "compact";
}

export const SectionTabsTab: React.FC<SectionTabsTabProps> & {
  tabsRole: string;
} = ({ children, icon = undefined, variant = "regular", ...otherProps }) => (
  <BaseTab
    className={cx({
      tab: true,
      tabVariantRegular: variant == "regular",
      tabVariantCompact: variant == "compact"
    })}
    {...otherProps}
  >
    {icon && <Icon name={icon} size="2.5x" />}
    {children}
  </BaseTab>
);
SectionTabsTab.tabsRole = "Tab";

export interface SectionTabsTabListProps {
  spacingTop?: null | "regular" | "compact";
  spacingBottom?: null | "regular" | "compact";
  className?: string;
}

export const SectionTabsTabList: React.FC<SectionTabsTabListProps> & {
  tabsRole: string;
} = ({ children, className, spacingTop, spacingBottom }) => (
  <BaseTabList
    className={cx({
      tabList: true,
      spacingTopRegular: spacingTop == "regular",
      spacingBottomRegular: spacingBottom == "regular",
      spacingTopCompact: spacingTop == "compact",
      spacingBottomCompact: spacingBottom == "compact",
      [className || ""]: className
    })}
  >
    {children}
  </BaseTabList>
);
SectionTabsTabList.tabsRole = "TabList";

export interface SectionTabsTabPanelProps {
  className?: string;
  forceRender?: boolean;
}

export const SectionTabsTabPanel: React.FC<SectionTabsTabPanelProps> & {
  tabsRole: string;
} = ({ children, className = "", ...otherProps }) => (
  <BaseTabPanel
    className={`${styles.tabPanel} ${className}`}
    selectedClassName={styles.tabPanelSelected}
    {...otherProps}
  >
    {children}
  </BaseTabPanel>
);
SectionTabsTabPanel.tabsRole = "TabPanel";

export interface CustomTabsProps {
  selectedIndex?: number;
  onSelect?: (index: number) => void;
}

const SectionTabs: React.FC<CustomTabsProps> = ({ children, ...props }) => {
  return (
    <BaseTabs className={styles.tabs} {...props}>
      {children}
    </BaseTabs>
  );
};

export default SectionTabs;
